<template>
  <div>
    <h3>Proporcione los datos del concierge</h3>
    <v-form ref="clienteForm">
      <v-row>
        <v-col cols="12" md="12">
          <v-text-field
            label="Nombre"
            v-model="Concierges.nom"
            :rules="Rules.requerido"
            outlined
            dense
            required
          ></v-text-field>
          <v-autocomplete
            v-if="Concierges.htl"
            label="Agencia"
            v-model="Concierges.htl.id"
            :items="Mayoristas"
            :rules="Rules.requerido"
            item-value="id"
            item-text="Nombre"
            outlined
            dense
            required
          ></v-autocomplete>
        </v-col>
        <v-col cols="6" md="6">
          <v-autocomplete
           v-if="Concierges.cms"
            label="Tipo comision"
            v-model="Concierges.cms.tp"
            :items="comisionTipos"
            item-value="id"
            outlined
            dense
            required
          ></v-autocomplete>
        </v-col>
        <v-col cols="6" md="6">
          <v-text-field
            label="Comisión"
            v-model="comision"
            outlined
            dense
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="12">
          <h4>Forma de pago</h4>
        </v-col>
        <v-col cols="3" md="3">
          <v-text-field
            label="Pago"
            v-model="formaPago.tp"
            item-value="id"
            outlined
            dense
            required
          ></v-text-field>
        </v-col>
        <v-col cols="3" md="3">
          <v-text-field
            label="Cantidad"
            v-model="formaPago.vl"
            outlined
            dense
            required
          ></v-text-field>
        </v-col>
        <v-col cols="3" md="3">
          <v-text-field
            label="Nota"
            v-model="formaPago.nt"
            outlined
            dense
            required
          ></v-text-field>
        </v-col>
        <v-col cols="3" md="3">
          <v-btn outlined color="primary" @click="addPayment">
            Agregar +
          </v-btn>
        </v-col>
        <v-col cols="12" md="12">
          <v-list>
            <v-list-item v-for="(pago, index) in Concierges.fdp" :key="index">
              <v-list-item-content>
                <v-list-item-title
                  >{{ pago.tp }}: {{ pago.vl }}</v-list-item-title
                >
                <p>Nota: {{ pago.nt }}</p>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn color="red" @click="deletePago(index)" dark>
                  Eliminar
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-col>
        <v-col cols="12" md="12">
          <h4>Contacto</h4>
        </v-col>
        <v-col cols="3" md="3">
          <v-text-field
            label="Tipo Contacto"
            v-model="contacto.tp"
            outlined
            dense
            required
          ></v-text-field>
        </v-col>
        <v-col cols="3" md="3">
          <v-text-field
            label="Info de contacto"
            v-model="contacto.vl"
            outlined
            dense
            required
          ></v-text-field>
        </v-col>
        <v-col cols="3" md="3">
          <v-btn outlined color="primary" @click="addContacto">
            Agregar +
          </v-btn>
        </v-col>
        <v-col cols="12" md="12">
          <v-list two-line>
            <v-list-item
              v-for="(contacto, index) in Concierges.mdc"
              :key="index"
            >
              <v-list-item-content>
                <v-list-item-title>
                  {{ contacto.tp }}: <b>{{ contacto.vl }}</b>
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn @click="deleteContact(index)" color="red" dark>
                  Eliminar
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
      <div class="text-right">
        <v-btn large @click="$emit('toggle', false)">Cancelar</v-btn>
        <v-btn
          style="margin-left: 6px"
          color="success"
          large
          @click="checkForm()"
          >Guardar</v-btn
        >
      </div>
    </v-form>
  </div>
</template>
<script>
import moment from "moment";
import Concierges from "../../clases/Concierges.js";
export default {
  name: "ConciergesForm.vue",
  components: {},
  props: ["edit", "dataEdit"],
  data() {
    return {
      menu: false,
      comisionTipos: [
        { id: "%", text: "% Porcentaje" },
        { id: "$", text: "$ Cantidad" },
      ],
      Mayoristas: [],
      formaPago: {
        tp: "",
        vl: "",
        nt: "",
      },
      contacto: {
        tp: "",
        vl: "",
      },
      comision:0,
      Concierges: Concierges.getPropertyModel(),
      Rules: Concierges.getRules(),
      errors: {},
      loader: true,
    };
  },
  methods: {
    deleteContact(index){
      this.Concierges.mdc.splice(index, 1);
      this.$forceUpdate();
    },
    deletePago(index){
      this.Concierges.fdp.splice(index, 1);
      this.$forceUpdate();
    },
    addPayment() {
      this.Concierges.fdp.push(this.formaPago);
      this.formaPago = {
        tp: "",
        vl: "",
        nt: "",
      };
      this.$forceUpdate();
    },
    addContacto() {
      this.Concierges.mdc.push(this.contacto);
      this.contacto = {
        tp: "",
        vl: "",
      };
      this.$forceUpdate();
    },
    checkForm() {
      if (this.$refs.clienteForm.validate()) {
        this.createConcierge(this.Concierges);
      }
    },
    createConcierge() {
      
      if(this.Concierges.cms.tp == "%"){
        this.Concierges.cms.vl = Number(this.comision)
      }else{
        this.Concierges.cms.vl = {C:0,M:this.$Currencies.getCurrencyDefault()}
        this.Concierges.cms.vl.C = Number(this.comision)
      }

      this.Concierges.htl.nm = this.$pgsHelper.getById(this.Mayoristas,"id",this.Concierges.htl.id).Nombre

      this.$alert.alertConfirm({
        action: "guardar",
        obj: "el concierge",
        route:(this.edit)? "RVA-Concierges-updateConcierge ":"RVA-Concierges-createConcierge",
        data: this.Concierges,
        onSuccess: () => {
          this.$emit("toggle", false);
          this.$emit("reload", false);
        },
      });
    },
    async getMayoristas() {
      this.Mayoristas = [];
      const snapshot = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "RVA/Mayoristas/Coleccion"
      );
      let arrayHoteles = Object.entries(snapshot.val());
      arrayHoteles.forEach((element) => {
        this.Mayoristas.push({ id: element[0], ...element[1] });
      });
    },
  },
  computed: {},
  watch: {},
  beforeMount: function() {
    this.loader = true;
  },
  mounted() {
    this.loader = false;
    this.getMayoristas();
    if (this.edit) {
      
      this.Concierges = new Concierges(this.dataEdit);
      if(this.Concierges.cms.tp == "%"){
        this.comision = this.Concierges.cms.vl
      }else{
        //this.Concierges.cms.vl = {C:0,M:"MXN"}
        this.comision = this.Concierges.cms.vl.C
      }
    } else {
      this.Concierges = new Concierges();
      if(this.Concierges.cms.tp == "%"){
        this.comision = this.Concierges.cms.vl
      }else{
        this.Concierges.cms.vl = {C:0,M:this.$Currencies.getCurrencyDefault()}
        this.comision = this.Concierges.cms.vl.C
      }
    }
  },
};
</script>
<style scoped>
.select2-container {
  width: 100% !important;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
